import { render, staticRenderFns } from "./label-edit.vue?vue&type=template&id=6b92ae74&scoped=true&"
import script from "./label-edit.vue?vue&type=script&lang=js&"
export * from "./label-edit.vue?vue&type=script&lang=js&"
import style0 from "./label-edit.vue?vue&type=style&index=0&id=6b92ae74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b92ae74",
  null
  
)

export default component.exports